import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CommentsPanelClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/DetailToolbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/MiniTalentCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/video/VideoDetailClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/video/VideoMoreFromClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/video/VideoRelatedClient.tsx");
